import IIIFClass, * as IIIFModule from './../../node_modules/ol/source/IIIF.js';

class IIIF extends IIIFClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in IIIFModule) {
    if (key !== "default") {
        IIIF[key] = IIIFModule[key];
    }
}

export default IIIF;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/IIIF.js';